/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { combineReducers } from 'redux';
import mapValues from 'lodash/mapValues';
import { APIStatus } from '../actions/api';

function defaultStateCreator(api) {
  return {
    data: api.response,
    error: api.error,
    status: APIStatus.name(api.status),
  };
}

/** Simple reducer for API middleware. */
export function createAPIReducer(actionType, stateCreator = defaultStateCreator) {
  return (state = {}, action) => {
    const { type, meta: { api } = {} } = action;

    if (type === actionType) {
      if (api.status === APIStatus.API_RESET) {
        return {
          api,
          data: undefined,
          error: undefined,
          status: undefined,
        };
      } else if (api.status) {
        return {
          api,
          ...stateCreator(api),
        };
      }
    }
    return state;
  };
}

/** Simple combine reducers for API middleware. */
export function combineAPIReducers(
  actionTypes,
  transformers = {},
  extraReducers = {},
) {
  const reducers = mapValues(
    actionTypes,
    (at, k) => createAPIReducer(at, transformers[k]));
  return combineReducers({
    ...reducers,
    ...extraReducers,
  });
}




// WEBPACK FOOTER //
// ./src/redux/reducers/api.js